import { Link } from "react-router-dom";
import { ShieldCheck, Phone, Stethoscope, Monitor, Clock, ArrowRight } from "lucide-react";

const FALLBACK_HERO = "https://images.unsplash.com/photo-1746439324737-2c9f9a3e81a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxob21lJTIwdGhlYXRlciUyMGx1eHVyeSUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3ODg1NDA2MDJ8MA&ixlib=rb-4.1.0&q=85";

export function Hero({ image }) {
  return (
    <section className="relative overflow-hidden">
      <div className="dg-grid-bg absolute inset-0" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-10 sm:pt-14 pb-14 sm:pb-20 grid lg:grid-cols-12 gap-8 lg:gap-10 items-center">
        <div className="lg:col-span-7 dg-reveal">
          <span className="dg-chip"><Stethoscope className="w-3 h-3" /> Phone & video<span className="hidden sm:inline"> sessions</span> · LA installs</span>
          <h1 className="mt-4 text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] font-display">
            Tech help you can <span className="text-cyan-400">actually reach</span> — by phone, video or in person.
          </h1>
          <p className="mt-5 text-slate-300 text-base sm:text-lg max-w-2xl">
            Dr.Gadget fixes your tech problems over a phone or video call — A/V, security cameras, Wi-Fi, computers, phones and gadgets — usually the same week. Need a TV mounted or cameras installed? David comes to you anywhere in the LA area.
          </p>
          <div className="mt-8 grid grid-cols-2 sm:flex sm:flex-wrap gap-3">
            <Link to="/book" className="dg-btn-primary rounded-full px-4 sm:px-6 py-3 text-sm flex items-center justify-center gap-2 whitespace-nowrap" data-testid="hero-book-btn">
              Book a Session <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/ask" className="dg-btn-ghost rounded-full px-4 sm:px-6 py-3 text-sm flex items-center justify-center gap-2 whitespace-nowrap" data-testid="hero-ask-btn">
              Ask Dr.Gadget
            </Link>
            <a href="tel:+13104220669" className="dg-btn-ghost rounded-full px-4 sm:px-6 py-3 text-sm flex items-center justify-center gap-2 col-span-2 sm:col-span-1" data-testid="hero-call-btn">
              <Phone className="w-4 h-4" /> 310-422-0669
            </a>
          </div>
          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-xs text-slate-400 font-mono uppercase tracking-widest">
            <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-cyan-400" /> Experienced hands-on tech</span>
            <span className="flex items-center gap-2"><Monitor className="w-4 h-4 text-cyan-400" /> Zoom · FaceTime · Meet · In person</span>
            <span className="flex items-center gap-2"><Clock className="w-4 h-4 text-cyan-400" /> Same-week sessions</span>
          </div>
        </div>
        <div className="lg:col-span-5 dg-reveal dg-reveal-2 relative">
          <div className="relative rounded-2xl overflow-hidden border border-slate-800 shadow-2xl">
            <img src={image || FALLBACK_HERO} alt="Remote tech support by video" loading="lazy" decoding="async" className="w-full h-64 sm:h-[440px] object-cover" data-testid="hero-image" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B1120] via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
              <div>
                <div className="dg-eyebrow">Solved by video</div>
                <div className="text-white font-medium">Home theater brought back to life over Zoom</div>
              </div>
              <span className="dg-chip">A/V</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
